// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2470":"52a85f1e","9909":"52a85f1e"}[chunkId] + ".chunk.css";
};